/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum QuoteFilterType {
  NoQuotes = "NoQuotes",
  NotManyQuotes = "NotManyQuotes",
  SuspiciouslyLow = "SuspiciouslyLow",
  CompanySignedUpInLastTwoWeeks = "CompanySignedUpInLastTwoWeeks",
  CompanySignedUpInLastTwoWeeksDaily = "CompanySignedUpInLastTwoWeeksDaily",
  CompanySignedUpInLastTwoWeeksWeekly = "CompanySignedUpInLastTwoWeeksWeekly",
  ShippingRookies = "ShippingRookies",
  NeverBooked = "NeverBooked",
  NeverBookedWeekly = "NeverBookedWeekly",
  NeverBookedDaily = "NeverBookedDaily",
  IncludesFlaggedServices = "IncludesFlaggedServices",
  FlaggedServiceIsInTwoCheapest = "FlaggedServiceIsInTwoCheapest",
  LargeShipment = "LargeShipment",
}

export function instanceOfQuoteFilterType(value: any): boolean {
  for (const key in QuoteFilterType) {
    if (Object.prototype.hasOwnProperty.call(QuoteFilterType, key)) {
      if (QuoteFilterType[key as keyof typeof QuoteFilterType] === value) {
        return true;
      }
    }
  }
  return false;
}

export function QuoteFilterTypeFromJSON(json: any): QuoteFilterType {
  return QuoteFilterTypeFromJSONTyped(json, false);
}

export function QuoteFilterTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteFilterType {
  return json as QuoteFilterType;
}

export function QuoteFilterTypeToJSON(value?: QuoteFilterType | null): any {
  return value as any;
}

export function QuoteFilterTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): QuoteFilterType {
  return value as QuoteFilterType;
}
